import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './style.css';

import axios from "axios";
//import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
//import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Table from 'react-bootstrap/Table';


const TeaStock = () => {

    const [purchases, setPurchases] = useState([]);
    const [editData, setEditData] = useState(null);
    const [clients, setClients] = useState([]);  // For client data
    const [products, setProducts] = useState([]);  // For product data

    useEffect(() => {
        // Fetch purchases data
        axios.get('https://react-apis.dotlocalhost.com/teaatockapi.php')
        .then(response => {
            setPurchases(response.data);
        })
        .catch(error => {
            console.error('Error fetching purchases:', error);
        });

        // Fetch clients data for dropdown
        axios.get('https://react-apis.dotlocalhost.com/purchaseClients.php')
        .then(response => {
            setClients(response.data);
        })
        .catch(error => {
            console.error('Error fetching clients:', error);
        });

        // Fetch products data for dropdown
        axios.get('https://react-apis.dotlocalhost.com/purchaseProTea.php')
        .then(response => {
            setProducts(response.data);
        })
        .catch(error => {
            console.error('Error fetching products:', error);
        });

        // sidebar background color set
        // Change background color of the specific sidebar item
        const sidebarItemmain = document.getElementById("teaprchg");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("teaprchgstk");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }        


        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }            
        };
    }, []);

    // Edit a row
    const handleEdit = (purchase) => {
        setEditData(purchase);
    };

    // Save edited data
    const handleEditSave = () => {
        const totalWeight = (editData.netWeight * editData.quantity) - editData.shortage;
        const totalBill = (totalWeight * editData.price) / 40;

        const updatedData = {
        ...editData,
        totalWeight,
        totalBill,
        };

        axios.post('https://react-apis.dotlocalhost.com/teaatockedit.php', updatedData)
        .then(response => {
            setPurchases(purchases.map(p => p.id === editData.id ? updatedData : p));
            setEditData(null);
        })
        .catch(error => {
            console.error('Error updating data:', error);
        });
    };

    // Handle clid change and update clientName accordingly
    const handleClidChange = (e) => {
        const selectedClid = e.target.value;
        const selectedClient = clients.find(client => client.clid === selectedClid);

        setEditData({
        ...editData,
        clid: selectedClid,
        clientName: selectedClient ? selectedClient.clientName : ''
        });
    };

    // Handle teaid change and update grade accordingly
    const handleProductidChange = (e) => {
        const selectedProductid = e.target.value;
        const selectedProduct = products.find(product => product.grade === selectedProductid);

        setEditData({
        ...editData,
        teaid: selectedProductid,
        grade: selectedProduct ? selectedProduct.grade : '',
        netWeight: selectedProduct ? selectedProduct.netWeight : ''
        });

    };
    

    // Delete a row
    const handleDelete = (id) => {
        axios.post('https://react-apis.dotlocalhost.com/teadelete.php', { id })
        .then(response => {
            setPurchases(purchases.filter(p => p.id !== id));
        })
        .catch(error => {
            console.error('Error deleting data:', error);
        });
    };


    //const [duedate, setDuedate] = useState([]);

    const calculateDaysLeft = (duedate) => {
        const currentDate = new Date();
        const inputs = new Date(duedate);
        const timeDiff = inputs - currentDate;
        const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        return daysLeft >= 0 ? daysLeft : 0; // Ensure no negative days
    };


    return (
        <div className="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Tea Purchased Goods</h3>
                        </div>
                    </div>

                    <Table striped bordered hover style={{ fontSize: '12px' }}>
                        <thead>
                            <tr style={{ textAlign: 'center', backgroundColor: '#C0D4D9', color: '#000000' }}>                                
                                <th>Client</th>
                                <th>Grade</th>
                                <th>Ship Mark</th>
                                <th>Pur. ID</th>                                
                                <th>Net Wgt</th>
                                <th>QTY</th>
                                <th>Short</th>
                                <th>T. Wgt</th>
                                <th>Price</th>
                                <th>Bill</th>
                                <th>Due date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {purchases.map(purchase => (
                                <tr key={purchase.id}>                                    
                                    <td>{purchase.clientName}</td>
                                    <td>{purchase.grade}</td>
                                    <td>{purchase.shipping_mark}</td>
                                    <td>{purchase.purchage_Id}</td>                                    
                                    <td>{purchase.netWeight}</td>
                                    <td>{purchase.quantity}</td>
                                    <td>{purchase.shortage}</td>
                                    <td>{purchase.totalWeight}</td>
                                    <td>{purchase.price}</td>
                                    <td>{purchase.totalBill}</td>                                    
                                    {calculateDaysLeft(purchase.duedate) < 3 &&(
                                        <td style={{ color: 'white', backgroundColor: 'red', fontWeight: '600', fontSize: '12px'}}>Over Due</td>
                                    )} {calculateDaysLeft(purchase.duedate) > 3 &&(
                                        <td style={{ color: 'Black', backgroundColor: 'white', fontWeight: '600', fontSize: '12px'}}>Limit available</td>
                                    )}
                                    <td>
                                        <button class="btn btn-warning" style={{ marginRight: "10px", fontSize: "10px" }} onClick={() => handleEdit(purchase)}>Edit</button>
                                        <Link to={`/view-purchase/${purchase.id}`} style={{ marginRight: "10px", fontSize: "10px" }} class="btn btn-success">View</Link>
                                        <button class="btn btn-danger" style={{ marginRight: "10px", fontSize: "10px" }} onClick={() => handleDelete(purchase.id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>


                    {editData && (
                        <div style={{marginTop: "50px", fontSize:"12px"}}>
                            <h3>Edit Purchase</h3>

                            <div className='row'>
                                <div className='col-2'>
                                    <label>Client ID:</label>
                                    <select className='form-control' style={{fontSize:"12px",height:"32px"}} value={editData.clid} onChange={handleClidChange}>
                                        <option value="">Select Client ID</option>
                                        {clients.map(client => (
                                            <option key={client.clid} value={client.clid}>
                                                {client.clid}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Client Name:</label>
                                    <input style={{fontSize:"12px"}} className='form-control' type="text" value={editData.clientName} readOnly />
                                </div>

                                <div className='col-2'>
                                    <label>Tea ID:</label>
                                    <select className='form-control' style={{fontSize:"12px",height:"32px"}} value={editData.grade} onChange={handleProductidChange}>
                                        <option value="">Select Tea ID</option>
                                        {products.map(product => (
                                            <option key={product.grade} value={product.grade}>
                                                {product.grade}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                
                                <div className='col-2'>
                                    <label for="" class="form-label">Grade:</label>
                                    <input style={{fontSize:"12px"}} className='form-control' type="text" value={editData.grade} readOnly />
                                </div>


                                <div className='col-2'>
                                    <label for="" class="form-label">Shipping Mark</label>
                                    <input style={{fontSize:"12px"}} type="text" className='form-control' value={editData.shipping_mark} onChange={(e) => setEditData({ ...editData, shipping_mark: e.target.value })} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Purchage ID</label>
                                    <input style={{fontSize:"12px"}} type="text" className='form-control' value={editData.purchage_Id} onChange={(e) => setEditData({ ...editData, purchage_Id: e.target.value })} readOnly/>
                                </div>                                                                
                            </div>

                            <div className='row'>                                
                                <div className='col-2'>
                                    <label for="" class="form-label">Net Weight</label>
                                    <input style={{fontSize:"12px"}} type="text" className='form-control' value={editData.netWeight} readOnly />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Quantity</label>
                                    <input style={{fontSize:"12px"}} type="text" className='form-control' value={editData.quantity} onChange={(e) => setEditData({ ...editData, quantity: e.target.value })} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Shortage</label>
                                    <input style={{fontSize:"12px"}} type="text" className='form-control' value={editData.shortage} onChange={(e) => setEditData({ ...editData, shortage: e.target.value })} />
                                </div>
                                <div className='col-2'>
                                    <label for="" class="form-label">Price</label>
                                    <input style={{fontSize:"12px"}} type="text" className='form-control' value={editData.price} onChange={(e) => setEditData({ ...editData, price: e.target.value })} />
                                </div>
                            </div>
                            
                            <div className='row' style={{marginLeft: "10px"}}>
                                <button class="btn btn-primary" onClick={handleEditSave} style={{marginRight: "10px", fontSize:"10px"}}>Save</button>
                                <button class="btn btn-danger" onClick={() => setEditData(null)} style={{marginRight: "10px", fontSize:"10px"}}>Cancel</button>
                            </div>

                        </div>
                    )}




                </div>

            </div>

        </div>
    )
}

export default TeaStock;